/**
 * Drag & Drop Item Types für react-dnd
 */
export const DND_TYPES = {
  DOKUMENT: 'DOKUMENT',
};
